<template>
  <div class="wallet-page bg-[#00554A] h-screen overflow-y-auto">
    <van-nav-bar :title="t('wallet.title')" class="custom-nav-bar" :border="false" :left-arrow="isFromPerson">
      <template #left>
        <Button v-if="isFromPerson" type="back" @click="onClickLeft" />
      </template>
      <template #right>
        <Button type="record" @click="goRecord" />
      </template>
    </van-nav-bar>
    <div class="mx-[14px] mt-[25px]">
      <div class="
        relative
        flex
        items-center
        h-[28px]
        pl-[10px]
        bg-[linear-gradient(90deg,#003829,#005542)]
        before:w-[2px]
        before:h-[28px]
        before:content-['']
        before:bg-[#00FFC7]
        before:absolute
        before:left-0
        before:top-0
        ">
        <div class="color-[#00F8C2] text-[12px] font-bold">
          <!-- Conta Saldo -->
          {{ t('wallet.accountBalance') }}
        </div>
        <div class="color-[#FEF64A] text-[12px] font-bold ml-[5px]">{{ VITE_symbol }} {{ numberFormat(balance) }}</div>
      </div>
      <div v-if="bettingMultiplier > 0" class="color-[#007C5C] text-[10px] font-bold flex pl-[10px]">
        <div>
          {{ t('wallet.bettingRequirement') }}
          <span style="color: #FEF64A;">{{ VITE_symbol }}{{ numberFormat(bettingMultiplier) }}</span>
        </div>
        <div @click="goToAuditPage" style="text-decoration: underline; cursor: pointer;margin-left: 5px;">
          {{ t('wallet.seeDetails') }}
        </div>
      </div>
      <div class="channels-container mt-[15px]">
        <div class="channels-scroll">
          <div class="Channels " v-for="(item, index) in withdrawalMethods" :key="index"
            :class="{ 'selected': selectedacite == index }" @click="alcieclick(item.value, index)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="w-full h-[1px] bg-[#009F76] mt-[10px]"></div>
      <div class="
        mt-[10px]
        relative
        flex
        items-center
        h-[28px]
        pl-[10px]
        bg-[linear-gradient(90deg,#003829,#005542)]
        before:w-[2px]
        before:h-[28px]
        before:content-['']
        before:bg-[#00FFC7]
        before:absolute
        before:left-0
        before:top-0
        ">
        <div class="color-[#00F8C2] text-[13px] font-bold ">
          <!-- Valor do Saque -->
          {{ t('wallet.withdrawAmount') }}
        </div>
      </div>

      <div class="recharge-grid">
        <div v-for="(amount, idx) in rechargeOptions" :key="amount" class="recharge-item"
          :class="{ selected: selectedRechargeIdx === idx }" @click="selectRecharge(idx)">
          <span class="recharge-item-content">{{ numberFormat(amount) }}</span>
        </div>
      </div>

      <!-- 自定义金额输入框 - 当 inputSwitch 为 true 时显示 -->
      <div v-if="inputSwitch" class="moneyseary">
        <div class="money-prefix">{{ VITE_symbol }}</div>
        <input v-model="searchText" class="search-input auth-input" type="text" :placeholder="dynamicPlaceholder"
          @input="handleInputChange" @keypress="handleKeyPress" @blur="handleInputBlur">
        <img :src="getAssetsFile('home/zu15.png')" alt="" class="money-icon" v-if="searchText != ''"
          @click="searchText = ''">
      </div>

      <div class="w-full h-[0.5px] bg-[#009F76] mt-[15px]"></div>
      <div class="
        mt-[10px]
        relative
        flex
        items-center
        h-[28px]
        pl-[10px]
        bg-[linear-gradient(90deg,#003829,#005542)]
        before:w-[2px]
        before:h-[28px]
        before:content-['']
        before:bg-[#00FFC7]
        before:absolute
        before:left-0
        before:top-0
        ">
        <div class="color-[#00F8C2] text-[15px] font-bold ">
          <!-- Metodo de Retirada -->
          {{ t('wallet.MetodoDeRetirada') }}
        </div>
      </div>

      <div class="Channels selected mt-[10px]">{{ t('wallet.bank') }}</div>

      <!-- Bank Card 表单 -->
      <!-- 菲律宾提现表单 -->
      <div>
        <div class="mt-[25px] relative" v-if="userbankcard.length > 0 && !isAddingNewBankCard">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.bankCard') }}</div>
          <input v-model="params.bankCardName" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterBankCard')" @focus="bankCardFocused = true"
            :readonly="true">
          <span class="arrow absolute right-0 bottom-0 transform -translate-y-full -translate-x-1/2 transform"
            :class="{ 'rotate-180': bankCardFocused }"></span>
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: bankCardFocused }"></div>
          </div>
        </div>
        <!-- 银行选择器 - 只在没有银行卡时或正在添加新银行卡时显示 -->
        <div v-if="userbankcard.length === 0 || isAddingNewBankCard" class="mt-[30px] relative"
          :class="{ 'mt-25px': userbankcard.length == 0 || isAddingNewBankCard }">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.bank') }}</div>
          <input v-model="params.flbBankName" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterBank')" @focus="showBankPicker = true"
            :readonly="true">
          <span class="arrow absolute right-0 bottom-0 transform -translate-y-full -translate-x-1/2 transform"
            :class="{ 'rotate-180': showBankPicker }"></span>
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: bankInputFocused }"></div>
          </div>
        </div>

        <!-- 银行卡号输入框 - GCash时隐藏 -->
        <div v-if="params.flbBankName !== 'GCash'" class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.bankAccountNumber') }}</div>
          <div class="relative">
            <input v-model="params.accountNumber" type="text" class="auth-input search-input mt-[14px] steinput"
              style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterAccount')" :maxlength="accountNumberMaxLength"
              @focus="accountInputFocused = true" @blur="handleAccountNumberBlur" @input="handleAccountNumberInput"
              @paste="handleAccountNumberPaste">
            <img :src="getAssetsFile('home/closes45.png')" alt=""
              class="absolute right-2 top-1/2 transform -translate-y-1/2 w-[9px] h-[9px] cursor-pointer"
              @click="params.accountNumber = ''; accountNumberError = false">
          </div>
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: accountInputFocused }"></div>
            <div v-if="accountNumberError" class="input-error-tip relative top-[5px] left-[0px]">
              <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
              <div class="ml-[2px] text-[12px]"> {{ t('wallet.gcashAccountFormatError') }}</div>
            </div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.withdrawalName') }}</div>
          <input v-model="params.accountHolder" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterName')" @focus="nameInputFocused = true"
            @blur="handleAccountHolderBlur">
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: nameInputFocused }"></div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.mobilePhone') }}</div>
          <div class="flex  mt-[14px]">
            <div class="flex items-center bg-[#00422F] rounded-[6px] px-3 py-2 border-r border-[#009F76]">
              <img :src="getAssetsFile('home/yignud.png')" alt="India" class="w-[18px] h-[12px] mr-2"
                style="object-fit: contain;">
              <span class="color-[#ffffff] text-[12px]">+{{ VITE_AREA_CODE }}</span>
              <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[8px] h-[8px]   ml-2 mb-[2px]"
                style="object-fit: contain;">
            </div>
            <input v-model="params.mobileNumber" type="text" class="auth-input search-input steinput flex-1"
              :placeholder="t('wallet.pleaseEnterPhone')" :maxlength="params.flbBankName === 'GCash' ? 11 : 999"
              @focus="phoneInputFocused = true" @blur="handleMobileNumberBlur" @input="handleMobileNumberInput"
              @paste="handleMobileNumberPaste">
          </div>
          <div class="flex  items-center justify-center justify-between">
            <div></div>
            <div class="w-73%  relative">
              <div class="input-underline" :class="{ focused: phoneInputFocused }"></div>
              <div v-if="mobileNumberError && params.flbBankName === 'GCash'"
                class="input-error-tip relative top-[5px] left-[0px]">
                <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
                <div class="ml-[2px] text-[12px]"> {{ t('wallet.gcashMobileFormatError') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="selectedWithdrawMethod === 'Bank Card'">
        <div class="mt-[25px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.bank') }}</div>
          <input v-model="params.bank" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterBank')" @focus="bankInputFocused = true"
            @blur="bankInputFocused = false">
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: bankInputFocused }"></div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.bankAccountNumber') }}</div>
          <div class="relative">
            <input v-model="params.bankAccountNumber" type="text" class="auth-input search-input mt-[14px] steinput"
              style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterAccount')" @focus="accountInputFocused = true"
              @blur="accountInputFocused = false">
            <img :src="getAssetsFile('home/closes45.png')" alt=""
              class="absolute right-2 top-1/2 transform -translate-y-1/2 w-[9px] h-[9px] cursor-pointer"
              @click="clearAccountNumber">
          </div>
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: accountInputFocused }"></div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.withdrawalName') }}</div>
          <input v-model="params.withdrawalName" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterName')" @focus="nameInputFocused = true"
            @blur="nameInputFocused = false">
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: nameInputFocused }"></div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.mobilePhone') }}</div>
          <div class="flex  mt-[14px]">
            <div class="flex items-center bg-[#00422F] rounded-[6px] px-3 py-2 border-r border-[#009F76]">
              <img :src="getAssetsFile('home/yignud.png')" alt="India" class="w-[18px] h-[12px] mr-2"
                style="object-fit: contain;">
              <span class="color-[#ffffff] text-[12px]">+{{ VITE_AREA_CODE }}</span>
              <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[8px] h-[8px]   ml-2 mb-[2px]"
                style="object-fit: contain;">
            </div>
            <input v-model="params.mobilePhone" type="text" class="auth-input search-input steinput flex-1"
              :placeholder="t('wallet.pleaseEnterPhone')" @focus="phoneInputFocused = true"
              @blur="phoneInputFocused = false">
          </div>
          <div class="flex  items-center justify-center justify-between">
            <div></div>
            <div class="w-73%  relative">
              <div class="input-underline" :class="{ focused: phoneInputFocused }"></div>
            </div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.email') }}</div>
          <input v-model="params.email" type="email" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterEmail')" @focus="emailInputFocused = true"
            @blur="emailInputFocused = false">
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: emailInputFocused }"></div>
          </div>
        </div>

        <div class="mt-[30px]">
          <div class="color-[#ffffff] text-[12px]">{{ t('wallet.ifscCode') }}</div>
          <input v-model="params.ifscCode" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" :placeholder="t('wallet.pleaseEnterIfsc')" @focus="ifscInputFocused = true"
            @blur="ifscInputFocused = false">
          <div class="w-full mt-[10px] relative">
            <div class="input-underline" :class="{ focused: ifscInputFocused }"></div>
          </div>
        </div>
      </div> -->

      <!-- UPI ID 表单 -->
      <!-- <div v-if="selectedWithdrawMethod === 'UPI ID'">
      <div class="mt-[25px]">
        <div class="color-[#ffffff] text-[12px]">{{ t('wallet.name') }}</div>
        <input
          v-model="params.upiName"
          type="text"
          class="auth-input search-input mt-[14px] steinput"
          style="margin-left: 0;"
          :placeholder="t('wallet.pleaseEnterName')"
          @focus="nameInputFocused = true"
          @blur="nameInputFocused = false"
        >
        <div class="w-full mt-[10px] relative">
          <div
            class="input-underline"
            :class="{ focused: nameInputFocused }"
          ></div>
        </div>
      </div>

      <div class="mt-[30px]">
        <div class="color-[#ffffff] text-[12px]">{{ t('wallet.phone') }}</div>
        <div class="relative">
          <input
            v-model="params.upiPhone"
            type="text"
            class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;"
            :placeholder="t('wallet.pleaseEnterAccount')"
            @focus="phoneInputFocused = true"
            @blur="phoneInputFocused = false"
          >
          <img
            :src="getAssetsFile('home/zu15.png')"
            alt=""
            class="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
            @click="clearPhoneNumber"
          >
        </div>
        <div class="w-full mt-[10px] relative">
          <div
            class="input-underline"
            :class="{ focused: phoneInputFocused }"
          ></div>
        </div>
      </div>

      <div class="mt-[30px]">
        <div class="color-[#ffffff] text-[12px]">{{ t('wallet.email') }}</div>
        <input
          v-model="params.upiEmail"
          type="email"
          class="auth-input search-input mt-[14px] steinput"
          style="margin-left: 0;"
          :placeholder="t('wallet.pleaseEnterEmail')"
          @focus="emailInputFocused = true"
          @blur="emailInputFocused = false"
        >
        <div class="w-full mt-[10px] relative">
          <div
            class="input-underline"
            :class="{ focused: emailInputFocused }"
          ></div>
        </div>
      </div>

      <div class="mt-[30px]">
        <div class="color-[#ffffff] text-[12px]">{{ t('wallet.upiIdField') }}</div>
        <input
          v-model="params.upiId"
          type="text"
          class="auth-input search-input mt-[14px] steinput"
          style="margin-left: 0;"
          :placeholder="t('wallet.pleaseEnterUpiId')"
          @focus="upiInputFocused = true"
          @blur="upiInputFocused = false"
        >
        <div class="w-full mt-[10px] relative">
          <div
            class="input-underline"
            :class="{ focused: upiInputFocused }"
          ></div>
        </div>
      </div>
    </div> -->

      <!-- 巴西 CPF 表单 -->
      <!-- <div class="mt-[25px]" v-if="false">
        <div class="color-[#ffffff] text-[12px]">Nome</div>
        <input v-model="params.cpfName" type="text" class="auth-input search-input mt-[14px] steinput"
          style="margin-left: 0;" placeholder="Por favor, insira o nome" @focus="nameInputFocused = true"
          @blur="nameInputFocused = false">
        <div class="w-full mt-[10px] relative">
          <div class="input-underline" :class="{ focused: nameInputFocused }"></div>
        </div>
      </div> -->

      <!-- <div class="mt-[30px]" v-if="false">
        <div class="color-[#ffffff] text-[12px]">CPF ID</div>
        <div class="relative">
          <input v-model="params.cpfId" type="text" class="auth-input search-input mt-[14px] steinput"
            style="margin-left: 0;" placeholder="Por favor, insira o CPF ID" @focus="cpfInputFocused = true"
            @blur="cpfInputFocused = false" @input="onCpfInput">
          <span v-if="params.cpfId"
            class="absolute right-2 top-2/3 transform -translate-y-1/2 text-[#89A89F] text-[18px] cursor-pointer  transition-colors"
            @click="clearCpfId">
            ×
          </span>
        </div>
        <div class="w-full mt-[10px] relative">
          <div class="input-underline" :class="{ focused: cpfInputFocused }"></div>
        </div>
        <div v-if="cpfError" class="input-error-tip relative top-[5px] left-[0px]">
          <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
          CPF inválido, por favor insira um CPF válido
        </div>
      </div>
      <div class="mt-[42px] flex justify-center">
        <Button class="Recharge mb-[40px]" :class="{ animated: rechargeBtnAnimated }" type="medium"
          @click="handleRechargeClick">
          {{ t('wallet.withdrawNow') }}
        </Button>
      </div> -->

      <div class="mt-[42px] flex justify-center">
        <Button class="Recharge mb-[40px]" :class="{ animated: rechargeBtnAnimated, disabled: isWithdrawDisabled }"
          type="medium" @click="handleRechargeClick" :disabled="isWithdrawDisabled">
          {{ t('wallet.withdrawNow') }}
        </Button>
      </div>
    </div>
    <van-popup v-model:show="showBankPicker" destroy-on-close round position="bottom">
      <div
        class="w-full h-full rounded-t-[13px] overflow-hidden pt-[2px] px-[2px] bg-[linear-gradient(0deg,#FFBF2F,#E6C32C)]">
        <van-picker ref="bankPickerRef" class="rounded-t-[13px] overflow-hidden" :model-value="[params.flbBankNameId]"
          :columns="withdrawbankname" @confirm="bankPickerConfirm">
          <template #toolbar>
            <div class="flex justify-end w-full py-[10px] px-[12px] rounded-t-[10px] overflow-hidden">
              <Button class="my-[10px] mx-[12px]" type="close" @click="showBankPicker = false" />
            </div>
          </template>
          <template #columns-bottom>
            <div class="w-full flex justify-center py-[10px]">
              <Button type="medium" @click="bankPickerConfirm">
                <span class="text-line-1-#034F39">{{ t('wallet.enter') }}</span>
              </Button>
            </div>
          </template>
        </van-picker>
      </div>
    </van-popup>
    <van-popup v-model:show="bankCardFocused" destroy-on-close round position="bottom">
      <div
        class="w-full h-full rounded-t-[13px] overflow-hidden pt-[2px] px-[2px] bg-[linear-gradient(0deg,#FFBF2F,#E6C32C)]">
        <van-picker ref="bankCardPickerRef" class="rounded-t-[13px] overflow-hidden"
          :model-value="[params.bankCardName]" :columns-field-names="{
            text: 'bankName',
            value: 'id'
          }" :columns="userbankcard">
          <template #toolbar>
            <div class="flex justify-end w-full  px-[12px]">
              <Button type="close" @click="bankCardFocused = false" />
            </div>
          </template>
          <template #option="option">
            <div class="flex h-full w-full items-center justify-center relative">
              <div class="w-full h-full flex items-center justify-center">
                {{ option.bankName }}
              </div>
              <div class="absolute w-1/6 h-full right-0 top-0 flex justify-center items-center"
                @click="deleteBankCard(option)">
                <img :src="getAssetsFile('home/bankDeleteIcon.png')" class="w-[9px] h-[9px]" alt="" srcset="">
              </div>
            </div>
          </template>
          <template #columns-bottom>
            <div class="w-full flex justify-center items-center gap-[10px] py-[10px]">
              <Button type="medium" @click="bankCardPickerConfirm">
                <span class="text-line-2px-#034F39">{{ t('wallet.enter') }}</span>
              </Button>
              <Button v-if="userbankcard.length < 9" type="medium" @click="handleAddBankCard">
                <span class="text-line-2px-#034F39">{{ t('wallet.addBankCard') }}</span>
              </Button>
            </div>
          </template>
        </van-picker>
      </div>

    </van-popup>
    <!-- Wellowtdog 弹窗 -->
    <wellowtdog v-model:show="showWellowtdogModal" :betting-multiplier="bettingMultiplier"
      @confirm="handleWellowtdogConfirm" @see-details="handleWellowtdogSeeDetails" />

    <!-- 安全密码弹窗 -->
    <SecurityPasswordDialog v-model:show="showSecurityPasswordModal" :from-page="'wallet'"
      @set-now="handleSetPasswordNow" @cancel="handleSecurityCancel" />

    <!-- 提现密码输入弹窗 -->
    <WithdrawPasswordDialog v-model:show="showWithdrawPasswordModal" :amount="Number(params.amount)"
      :withdraw-params="withdrawParams" @success="handleWithdrawPasswordSuccess" @error="handleWithdrawPasswordError" />

    <!-- 删除银行卡确认弹窗 -->
    <DeleteBankCardDialog v-model:show="showDeleteBankCardDialog" @confirm="handleDeleteBankCardConfirm" />
  </div>
</template>

<script setup lang="ts">
import { Border } from "@/components/Border"
import { Button } from "@/components/Button"
import { useUserStore } from '@/stores/modules/user'
import * as GameApi from "@/api/game";
import { useRouter } from 'vue-router'
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { numberFormat } from '@/utils/formatter'
import { trackWithdrawClickMethodButton, trackWithdrawClickNowButton } from '@/utils/firebase-analytics'
import { getAssetsFile } from '@/utils/pub-use'
import Wellowtdog from '@/components/wellowtdog.vue'
import SecurityPasswordDialog from '@/components/SecurityPasswordDialog.vue'
import WithdrawPasswordDialog from '@/components/WithdrawPasswordDialog.vue'
import DeleteBankCardDialog from '@/components/DeleteBankCardDialog.vue'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const { t } = useI18n()
const VITE_AREA_CODE = import.meta.env.VITE_AREA_CODE
const router = useRouter()
const showBankPicker = ref(false)
const withdrawbankname = ref([])
const userbankcard = ref([])
const bankCardFocused = ref(false)
const isAddingNewBankCard = ref(false) // 是否正在添加新银行卡
const userStore = useUserStore()
const cpfInputFocused = ref(false)
const phoneInputFocused = ref(false)
const emailInputFocused = ref(false)
const nameInputFocused = ref(false)
const bankInputFocused = ref(false)
const accountInputFocused = ref(false)
const ifscInputFocused = ref(false)
const upiInputFocused = ref(false)  // 新增
const rechargeBtnAnimated = ref(false)

// CPF验证相关状态
const cpfError = ref(false)
// GCash账号验证相关状态
const accountNumberError = ref(false)
// 手机号验证相关状态
const mobileNumberError = ref(false)
const selectedacite = ref(0)
const parsmestype = ref('1') // 默认值为字符串 '1'
const withdrawalMethods = ref([])
const alcieclick = (value, index) => {
  selectedacite.value = index
  parsmestype.value = value
  // 切换提现方式时清除账号错误状态和手机号错误状态
  accountNumberError.value = false
  mobileNumberError.value = false
}

// Wellowtdog 弹窗相关
const showWellowtdogModal = ref(false)
const bettingMultiplier = ref(0)

// 安全密码弹窗相关
const showSecurityPasswordModal = ref(false)

// 提现密码弹窗相关
const showWithdrawPasswordModal = ref(false)
const withdrawParams = ref<any>({}) // 存储提现参数
const withdrawPasswordSwitch = ref(false) // 提现密码开关，true=显示密码弹窗，false=隐藏密码弹窗

// 删除银行卡弹窗相关
const showDeleteBankCardDialog = ref(false)
const currentDeleteBankCard = ref<any>(null) // 当前要删除的银行卡信息
const isWithdrawing = ref(false) // 是否正在提现中，用于防抖

const balance = computed(() => {
  // 从 userWalletInfos 数组中获取第一个钱包的可用余额
  const walletInfos = userStore.userInfo.userWalletInfos;
  return walletInfos?.find((item: any) => item.currencyId != 3)?.availableAccount || '0';
})

const selectedChannelId = ref(null); // 保留渠道ID，用于后续提现请求

// 将 rechargeOptions 的定义移到这里，在 onMounted 之前
const rechargeOptions = ref([])
const selectedRechargeIdx = ref(-1)

// 添加响应式变量来存储接口返回的配置
const inputSwitch = ref(false)
const maxAmount = ref(50000)
const minAmount = ref(5)
// 获取所有的银行名称
const getWithdrawBankName = async () => {
  const res = await GameApi.withdrawbankname();
  withdrawbankname.value = []
  for (let key in res.data.idNameMap) {
    withdrawbankname.value.push({
      text: res.data.idNameMap[key],
      value: Number(key)
    })
  }
  console.log(withdrawbankname.value, 'withdrawbankname');
}
// 获取用户所有的银行卡
const getUserBankCard = async () => {
  const res = await GameApi.obtainedbankallInformation(null);
  userbankcard.value = res.data;

}
const bankPickerRef = ref(null)
const bankCardPickerRef = ref(null)
const bankPickerConfirm = () => {
  const value = bankPickerRef.value?.getSelectedOptions()
  if (!value[0]) return
  params.value.flbBankNameId = value[0].value;
  params.value.flbBankName = value[0].text;

  // GCash不需要银行卡号，清除账号错误状态
  if (params.value.flbBankName === 'GCash') {
    accountNumberError.value = false
  }

  showBankPicker.value = false;
}
const bankCardPickerConfirm = () => {
  const value = bankCardPickerRef.value?.getSelectedOptions()
  const data = value[0]
  if (!data) return

  params.value = {
    ...params.value,
    ...data
  }
  params.value.bankCardName = data.bankName;
  params.value.bankAccountId = data.id;
  const bankname = withdrawbankname.value.find((item) => {
    // console.log(item.value,data.flbBankNameId, "item.value == data.flbBankNameId")
    return item.value == data.flbBankNameId
  })
  // console.log(bankname, data, "bankname")
  params.value.flbBankName = bankname?.text

  // GCash不需要银行卡号，清除账号错误状态
  if (params.value.flbBankName === 'GCash') {
    accountNumberError.value = false
  }

  // 重置新增银行卡状态（用户选择了已有银行卡）
  isAddingNewBankCard.value = false

  bankCardFocused.value = false;
}
// 删除银行卡
const deleteBankCard = (option) => {
  currentDeleteBankCard.value = option
  showDeleteBankCardDialog.value = true
}

// 处理新增银行卡
const handleAddBankCard = () => {
  // 关闭银行卡选择器
  bankCardFocused.value = false
  // 设置正在添加新银行卡状态
  isAddingNewBankCard.value = true
  // 清空当前表单数据，准备添加新银行卡
  params.value.flbBankName = ''
  params.value.flbBankNameId = ''
  params.value.accountNumber = ''
  params.value.accountHolder = ''
  params.value.mobileNumber = ''
  params.value.bankCardName = ''
  params.value.bankAccountId = ''
  // 打开银行选择器
  showBankPicker.value = true
}

// 确认删除银行卡
const handleDeleteBankCardConfirm = async () => {
  if (!currentDeleteBankCard.value) return

  try {
    const res = await GameApi.deletebankInformation(currentDeleteBankCard.value.id)
    // 如果当前选中的银行卡被删除，清空选中状态
    if (params.value.bankAccountId === currentDeleteBankCard.value.id) {
      params.value.bankAccountId = '';
      params.value.bankCardName = '';
      params.value.flbBankName = '';
      params.value.flbBankNameId = '';
      params.value.accountNumber = '';
      params.value.accountHolder = '';
      params.value.mobileNumber = '';
    }
    await getUserBankCard()
    if (userbankcard.value.length === 0) {
      bankCardFocused.value = false;
    }
    currentDeleteBankCard.value = null
  } catch (error: any) {
    console.error('删除银行卡失败:', error)
      ; (window as any).$toast(error?.msg || error?.message)
    currentDeleteBankCard.value = null
  }
}
// 获取提现方式列表
const getWithdrawTypeList = async () => {
  try {
    const res = await GameApi.getWithdrawTypeList()
    if (res && res.data && Array.isArray(res.data)) {
      // 将接口返回的数据映射为 { label, value } 格式
      withdrawalMethods.value = res.data.map((item: any) => ({
        label: item.name || item.label || item.typeName || '',
        value: String(item.type)
      }))
      // 如果有数据，优先选中 value 为 '1' 的渠道，否则选中第一个
      if (withdrawalMethods.value.length > 0) {
        const defaultIndex = withdrawalMethods.value.findIndex((item: any) => item.value === '1')
        if (defaultIndex !== -1) {
          // 找到 value 为 '1' 的渠道，默认选中它
          selectedacite.value = defaultIndex
          parsmestype.value = '1'
        } else {
          // 没有 value 为 '1' 的渠道，默认选中第一个
          selectedacite.value = 0
          parsmestype.value = withdrawalMethods.value[0].value
        }
      }
    }
  } catch (error) {
    console.error('获取提现方式列表失败:', error)
    // 如果接口失败，使用默认值
    withdrawalMethods.value = [
      { label: 'GCash', value: '1' },
      { label: 'MAYA', value: '2' },
    ]
    // 接口失败时，默认值已经是 1，不需要修改
  }
}

// 在 onMounted 中添加获取投注倍数的逻辑
onMounted(async () => {
  await withdrawalConfigurations()
  getWithdrawBankName();
  getUserBankCard();
  await getWithdrawTypeList(); // 获取提现方式列表
  // 保留渠道获取逻辑，用于获取提现档位
  const res1 = await GameApi.withdrawgetall();
  selectedChannelId.value = res1.data.id;
  rechargeOptions.value = res1.data.withdrawItem

  // 获取输入框配置
  inputSwitch.value = res1.data.inputSwitch || false
  maxAmount.value = res1.data.maxAmount || 50000
  minAmount.value = res1.data.minAmount || 5

  // 默认选中第一个金额
  if (rechargeOptions.value && rechargeOptions.value.length > 0) {
    selectRecharge(0)
  }

  // 添加：页面加载时获取投注倍数
  try {
    const response = await GameApi.info()
    const data = response.data as any
    bettingMultiplier.value = data.bettingMultiplier || 0
  } catch (error) {
    console.error('获取投注倍数失败:', error)
    bettingMultiplier.value = 0
  }
})
const withdrawalConfigurations = async () => {
  try {
    const res = await GameApi.withdrawalConfiguration()
    // 保存提现密码开关状态
    if (res && res.data) {
      withdrawPasswordSwitch.value = res.data.withdrawPasswordSwitch || false
    }
  } catch (error) {
    console.error('Failed to get withdrawal configuration:', error)
    withdrawPasswordSwitch.value = false
  }
}
// 自定义格式化函数，使用逗号作为千分符
const formatWithDotSeparator = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 添加计算属性来生成动态placeholder
const dynamicPlaceholder = computed(() => {
  if (inputSwitch.value) {
    // 使用自定义格式化函数，添加逗号作为千位分隔符
    const formattedMin = formatWithDotSeparator(minAmount.value)
    const formattedMax = formatWithDotSeparator(maxAmount.value)
    return `${formattedMin} - ${formattedMax}`
  }
  return "" // 默认值
})

// GCash账号最大长度计算属性
const accountNumberMaxLength = computed(() => {
  return params.value.flbBankName === 'GCash' ? 11 : 999
})

// 判断是否应该禁用提现按钮
const isWithdrawDisabled = computed(() => {
  // 如果银行名称是GCash
  if (params.value.flbBankName === 'GCash') {
    // GCash不需要银行卡号，只验证手机号格式
    // 如果手机号格式错误，则禁用按钮
    if (mobileNumberError.value) {
      return true
    }
  }
  return false
})

// 保留渠道选择函数，用于切换渠道时更新提现档位
const selectChannel = (id) => {
  selectedChannelId.value = id;

}

const searchText = ref('')

// 处理输入变化，移除小数点并添加金额验证
const handleInputChange = (event) => {
  const value = event.target.value
  // 移除所有非数字字符（包括小数点）
  const cleanValue = value.replace(/[^0-9]/g, '')

  // 如果输入为空，直接设置
  if (!cleanValue) {
    searchText.value = cleanValue
    return
  }

  const inputAmount = parseFloat(cleanValue)

  // 获取余额（移除逗号并转换为数字）
  const balanceStr = String(balance.value || '0')
  const balanceAmount = parseFloat(balanceStr.replace(/,/g, ''))

  let finalAmount = inputAmount

  // 只有在用户输入完成后（失去焦点或按回车）才进行验证
  // 这里只做基本的输入处理，不强制修正
  searchText.value = cleanValue
}

// 添加新的函数来处理输入完成后的验证
const handleInputBlur = () => {
  if (!searchText.value) return

  const inputAmount = parseFloat(searchText.value)

  // 获取余额（移除逗号并转换为数字）
  const balanceStr = String(balance.value || '0')
  const balanceAmount = parseFloat(balanceStr.replace(/,/g, ''))

  let finalAmount = inputAmount

  // 1. 如果输入金额小于最小金额，设置为最小金额
  if (inputAmount < minAmount.value) {
    finalAmount = minAmount.value
  }
  // 2. 如果输入金额大于最大金额，设置为最大金额
  else if (inputAmount > maxAmount.value) {
    finalAmount = maxAmount.value
  }
  // 3. 如果输入金额大于余额，设置为余额
  else if (inputAmount > balanceAmount) {
    finalAmount = balanceAmount
  }

  // 只有当值发生变化时才更新
  if (finalAmount !== inputAmount) {
    searchText.value = Math.floor(finalAmount).toString()
  }
}

// 阻止小数点输入
const handleKeyPress = (event) => {
  // 阻止小数点、减号等字符输入
  if (['.', '-', 'e', 'E'].includes(event.key)) {
    event.preventDefault()
  }
}

// 创建 params 对象来存储所有表单数据
const params = ref({
  flbBankNameId: '',
  flbBankName: "",
  bankAccountId: '',
  accountNumber: '',
  accountHolder: '',
  bankCardName: '',
  mobileNumber: '',
  // 提现金额
  amount: '',
  // Bank Card 表单字段
  bank: '',
  bankAccountNumber: '',
  withdrawalName: '',
  mobilePhone: '',
  email: '',
  ifscCode: '',
  // UPI ID 表单字段
  upiName: '',
  upiPhone: '',
  upiEmail: '',
  upiId: '',
  // 巴西 CPF 表单字段
  cpfName: '',
  cpfId: '',
  // 提现方式
  withdrawMethod: 'Bank Card'
})

// 添加一个计算属性来检查当前输入值是否匹配预设金额
const currentInputMatchesPreset = computed(() => {
  if (!searchText.value) return -1

  // 将输入值与预设金额的整数部分进行比较
  for (let i = 0; i < rechargeOptions.value.length; i++) {
    const presetNum = String(rechargeOptions.value[i]).replace('.00', '')
    if (searchText.value === presetNum) {
      return i
    }
  }
  return -1
})

// 监听 searchText 变化，同步到 params
watch(searchText, (newValue) => {
  // 如果 inputSwitch 为 false，不处理自定义输入
  if (!inputSwitch.value) {
    return
  }

  const matchIndex = currentInputMatchesPreset.value
  selectedRechargeIdx.value = matchIndex

  // 检查输入金额是否超过余额
  if (newValue && !isNaN(Number(newValue))) {
    const inputAmount = parseFloat(newValue)
    // 确保 balance.value 是字符串，然后移除逗号并转换为数字
    const balanceStr = String(balance.value || '0')
    const balanceAmount = parseFloat(balanceStr.replace(/,/g, ''))

    if (inputAmount > balanceAmount) {
      // 如果输入金额超过余额，延迟一下再自动赋值为余额，让用户看到输入过程
      setTimeout(() => {
        searchText.value = balanceAmount.toString()
        params.value.amount = balanceAmount.toString()
      }, 500) // 500毫秒后自动修正
      return
    }
  }

  // 同步金额到 params
  params.value.amount = newValue
})

// 监听银行名称变化，如果是GCash，只校验手机号（GCash不需要银行卡号）
watch(() => params.value.flbBankName, (newBankName) => {
  if (newBankName === 'GCash') {
    // GCash不需要银行卡号，只校验手机号
    if (params.value.mobileNumber) {
      mobileNumberError.value = !validateGCashMobile(params.value.mobileNumber)
    }
    // 清除银行卡号错误状态（GCash不需要）
    accountNumberError.value = false
  } else {
    // 如果不是GCash，清除所有错误状态
    accountNumberError.value = false
    mobileNumberError.value = false
  }
})

function selectRecharge(idx) {
  const raw = rechargeOptions.value[idx]
  // 确保 raw 是字符串类型，然后去掉 .00 后缀，只保留整数部分
  const num = String(raw).replace('.00', '')

  // 检查选择的金额是否超过余额
  const selectedAmount = parseFloat(num)
  const balanceStr = String(balance.value || '0')
  const balanceAmount = parseFloat(balanceStr.replace(/,/g, ''))

  if (selectedAmount > balanceAmount) {
    // 如果选择的金额超过余额，不执行选择操作
    return
  }

  selectedRechargeIdx.value = idx
  searchText.value = num
  // 同步金额到 params
  params.value.amount = num
}

const withdrawMethods = computed(() => [

])
const selectedWithdrawMethod = ref('Bank Card')

function selectWithdrawMethod(val) {
  trackWithdrawClickMethodButton({ method: val })
  selectedWithdrawMethod.value = val
  // 同步提现方式到 params
  params.value.withdrawMethod = val
}

function clearAccountNumber() {
  // 清除银行账号输入框的内容
  params.value.bankAccountNumber = ''
}

function clearPhoneNumber() {
  // 清除手机号输入框的内容
  if (selectedWithdrawMethod.value === 'Bank Card') {
    params.value.mobilePhone = ''
  } else {
    params.value.upiPhone = ''
  }
}

function clearCpfId() {
  // 清除 CPF ID 输入框的内容
  params.value.cpfId = ''
  cpfError.value = false
}

// 巴西CPF验证算法
function isValidCPF(cpf: string): boolean {
  // 移除所有非数字字符
  cpf = cpf.replace(/\D/g, '')

  // 检查长度
  if (cpf.length !== 11) return false

  // 检查是否所有数字都相同 (如: 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) return false

  // 验证第一个校验位
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i)
  }
  let remainder = sum % 11
  let firstDigit = remainder < 2 ? 0 : 11 - remainder

  if (parseInt(cpf.charAt(9)) !== firstDigit) return false

  // 验证第二个校验位
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i)
  }
  remainder = sum % 11
  let secondDigit = remainder < 2 ? 0 : 11 - remainder

  return parseInt(cpf.charAt(10)) === secondDigit
}

// CPF输入处理
function onCpfInput(e: Event) {
  const val = (e.target as HTMLInputElement).value.replace(/\D/g, '')
  // 限制最大长度为11位
  const limitedVal = val.length > 11 ? val.substring(0, 11) : val
  params.value.cpfId = limitedVal
  // CPF必须是11位数字且通过验证算法
  cpfError.value = limitedVal.length > 0 && (limitedVal.length !== 11 || !isValidCPF(limitedVal))
}

// GCash账号校验函数
function validateGCashAccount(accountNumber: string): boolean {
  if (!accountNumber) return true // 空值不显示错误，由必填校验处理
  // 必须是11位数字
  if (accountNumber.length !== 11) return false
  // 必须以09开头
  if (!accountNumber.startsWith('09')) return false
  // 必须全部是数字
  return /^\d+$/.test(accountNumber)
}

// GCash手机号校验函数
function validateGCashMobile(mobileNumber: string): boolean {
  if (!mobileNumber) return true // 空值不显示错误，由必填校验处理
  // 必须是11位数字
  if (mobileNumber.length !== 11) return false
  // 必须以09开头
  if (!mobileNumber.startsWith('09')) return false
  // 必须全部是数字
  return /^\d+$/.test(mobileNumber)
}

// 处理账号输入
function handleAccountNumberInput(e: Event) {
  const input = e.target as HTMLInputElement
  let value = input.value
  // 只允许输入数字
  let cleanValue = value.replace(/\D/g, '')

  // 如果银行名称是GCash，限制最多输入11位
  if (params.value.flbBankName === 'GCash') {
    // 严格限制为11位
    if (cleanValue.length > 11) {
      cleanValue = cleanValue.substring(0, 11)
    }
    // 直接更新值，v-model 会自动同步
    params.value.accountNumber = cleanValue
    // 如果输入框的值与清理后的值不一致，强制更新
    if (input.value !== cleanValue) {
      input.value = cleanValue
    }
    // 进行实时校验
    accountNumberError.value = cleanValue.length > 0 && !validateGCashAccount(cleanValue)
  } else {
    params.value.accountNumber = cleanValue
    accountNumberError.value = false
  }
}

// 处理账号失去焦点
function handleAccountNumberBlur() {
  accountInputFocused.value = false
  // 如果银行名称是GCash，进行校验
  if (params.value.flbBankName === 'GCash' && params.value.accountNumber) {
    accountNumberError.value = !validateGCashAccount(params.value.accountNumber)
  } else {
    accountNumberError.value = false
  }
}

// 处理账号粘贴
function handleAccountNumberPaste(e: ClipboardEvent) {
  if (params.value.flbBankName === 'GCash') {
    // 阻止默认粘贴行为
    e.preventDefault()
    // 获取粘贴的内容
    const pastedText = (e.clipboardData || (window as any).clipboardData).getData('text')
    // 只保留数字
    let cleanValue = pastedText.replace(/\D/g, '')
    // 限制为11位
    cleanValue = cleanValue.length > 11 ? cleanValue.substring(0, 11) : cleanValue
    // 更新值
    params.value.accountNumber = cleanValue
    // 进行校验
    accountNumberError.value = cleanValue.length > 0 && !validateGCashAccount(cleanValue)
  }
}

// 处理手机号输入
function handleMobileNumberInput(e: Event) {
  const input = e.target as HTMLInputElement
  let value = input.value
  // 只允许输入数字
  let cleanValue = value.replace(/\D/g, '')

  // 如果银行名称是GCash，限制最多输入11位
  if (params.value.flbBankName === 'GCash') {
    // 严格限制为11位
    if (cleanValue.length > 11) {
      cleanValue = cleanValue.substring(0, 11)
    }
    // 直接更新值，v-model 会自动同步
    params.value.mobileNumber = cleanValue
    // 如果输入框的值与清理后的值不一致，强制更新
    if (input.value !== cleanValue) {
      input.value = cleanValue
    }
    // 进行实时校验
    mobileNumberError.value = cleanValue.length > 0 && !validateGCashMobile(cleanValue)
  } else {
    params.value.mobileNumber = cleanValue
    mobileNumberError.value = false
  }
}

// 处理手机号失去焦点
function handleMobileNumberBlur() {
  phoneInputFocused.value = false
  // 如果银行名称是GCash，进行校验
  if (params.value.flbBankName === 'GCash' && params.value.mobileNumber) {
    mobileNumberError.value = !validateGCashMobile(params.value.mobileNumber)
  } else {
    mobileNumberError.value = false
  }
}

// 处理账户持有人姓名失去焦点
function handleAccountHolderBlur() {
  nameInputFocused.value = false
  // 去除首尾空格
  if (params.value.accountHolder) {
    params.value.accountHolder = params.value.accountHolder.trim()
  }
}

// 处理手机号粘贴
function handleMobileNumberPaste(e: ClipboardEvent) {
  if (params.value.flbBankName === 'GCash') {
    // 阻止默认粘贴行为
    e.preventDefault()
    // 获取粘贴的内容
    const pastedText = (e.clipboardData || (window as any).clipboardData).getData('text')
    // 只保留数字
    let cleanValue = pastedText.replace(/\D/g, '')
    // 限制为11位
    cleanValue = cleanValue.length > 11 ? cleanValue.substring(0, 11) : cleanValue
    // 更新值
    params.value.mobileNumber = cleanValue
    // 进行校验
    mobileNumberError.value = cleanValue.length > 0 && !validateGCashMobile(cleanValue)
  }
}

// 合并检查函数，只调用一次 info 接口
async function checkWithdrawConditions() {
  const response = await GameApi.info()
  // 修复类型错误，使用 any 类型或正确的接口
  const data = response.data as any
  const { bettingMultiplier: apiBettingMultiplier, withdrawPassword } = data

  // 第一步：检查 bettingMultiplier > 0
  if (apiBettingMultiplier > 0) {
    bettingMultiplier.value = apiBettingMultiplier
    showWellowtdogModal.value = true
    return { hasMultiplier: true, needPassword: false }
  }

  // 如果 withdrawPasswordSwitch 为 false，跳过所有密码相关检查（不显示密码弹窗）
  if (!withdrawPasswordSwitch.value) {
    return { hasMultiplier: false, needPassword: false, needInputPassword: false }
  }

  // 第二步：检查是否需要设置二级密码
  if (withdrawPassword == null) {
    showSecurityPasswordModal.value = true
    return { hasMultiplier: false, needPassword: true }
  }

  // 第三步：如果已设置二级密码，弹出输入密码弹窗
  if (withdrawPassword) {
    // 准备提现参数
    await prepareWithdrawParamsOnly()
    showWithdrawPasswordModal.value = true
    return { hasMultiplier: false, needPassword: false, needInputPassword: true }
  }

  // 都不需要，直接提现
  return { hasMultiplier: false, needPassword: false, needInputPassword: false }
}
const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
// 准备提现参数，不调用 create 接口
async function prepareWithdrawParamsOnly() {
  try {
    // 准备参数 - 所有渠道都使用相同的逻辑
    const bankParams: any = {
      flbBankNameId: params.value.flbBankNameId,
      bankName: params.value.flbBankName,
      accountHolder: params.value.accountHolder,
      mobileNumber: params.value.mobileNumber,
      // 如果有 bankAccountId，也传递（用于已有银行卡的情况）
      ...(params.value.bankAccountId && { bankAccountId: params.value.bankAccountId }),
    }

    // GCash不需要传递accountNumber，其他银行需要
    if (params.value.flbBankName !== 'GCash') {
      bankParams.accountNumber = params.value.accountNumber
    }

    withdrawParams.value = {
      userId: userStore.userInfo.userId,
      withdrawAmount: Number(params.value.amount),
      currency: VITE_PLATFORM,
      paymentType: Number(parsmestype.value), // 转换为数字：1=GCash, 2=MAYA
      bankParams
    }

    // 添加调试日志
    console.log('准备提现参数:', {
      paymentType: withdrawParams.value.paymentType,
      bankParams: withdrawParams.value.bankParams
    })

    // 注释：原来的 Bank Card 和 UPI 逻辑保留备用
    // if (selectedWithdrawMethod.value === 'Bank Card') {
    //   // 验证 Bank Card 必填字段
    //   if (!params.value.bank || !params.value.bankAccountNumber || !params.value.withdrawalName ||
    //       !params.value.mobilePhone || !params.value.email || !params.value.ifscCode) {
    //   }
    //
    //   // Bank Card 方式 - 准备参数
    //   withdrawParams.value = {
    //     userId: userStore.userInfo.userId,
    //     withdrawAmount: Number(params.value.amount),
    //     currency: VITE_PLATFORM,
    //     bankParams: {
    //       bankName: params.value.bank,
    //       accountNumber: params.value.bankAccountNumber,
    //       accountHolder: params.value.withdrawalName,
    //       mobileCountryCode:VITE_AREA_CODE,
    //       mobileNumber: params.value.mobilePhone,
    //       email: params.value.email,
    //       ifscCode: params.value.ifscCode,
    //       userId: userStore.userInfo.userId,
    //       userName: userStore.userInfo.userId
    //     },
    //     paymentType: 2 // 2表示银行卡
    //   }
    // } else if (selectedWithdrawMethod.value === 'UPI ID') {
    //   // 验证 UPI ID 必填字段
    //   if (!params.value.upiName || !params.value.upiPhone || !params.value.upiEmail || !params.value.upiId) {
    //   }
    //
    //   // UPI ID 方式 - 准备参数
    //   withdrawParams.value = {
    //     userId: userStore.userInfo.userId,
    //     withdrawAmount: Number(params.value.amount),
    //     currency: VITE_PLATFORM,
    //     upiParams: {
    //       upi: params.value.upiId,
    //       accountHolder: params.value.upiName,
    //       mobileCountryCode: VITE_AREA_CODE,
    //       mobileNumber: params.value.upiPhone,
    //       email: params.value.upiEmail
    //     },
    //     paymentType: 1 // 1表示UPI
    //   }
    // } else {
    // }
  } catch (error) {
    throw error
  }
}
// 处理设置密码
function handleSetPasswordNow(fromPage: string) {
  showSecurityPasswordModal.value = false
  // 跳转到验证登录密码页面，并传递重定向参数和来源页面
  router.push({
    path: '/security/parssord',
    query: {
      redirect: 'senha',
      fromPage: fromPage
    }
  })
}

// 处理取消
function handleSecurityCancel() {
  showSecurityPasswordModal.value = false
    // 用户取消了设置二级密码，终止提现流程
    // 可以显示提示信息
    ; (window as any).$toast('has cancelled')
}

// 处理 Wellowtdog 弹窗确认
function handleWellowtdogConfirm() {
  showWellowtdogModal.value = false
}

// 处理查看详情
function handleWellowtdogSeeDetails() {
  // 这里可以跳转到详情页面或者显示更多信息
  // 例如：router.push('/activity/betting-multiplier')
}

// 处理提现密码确认
async function handleWithdrawPasswordSuccess() {
  showWithdrawPasswordModal.value = false
  isWithdrawing.value = false
  // 提现成功，刷新用户信息和银行卡列表
  try {
    await userStore.info()
    // 判断是否创建了新银行卡（如果 withdrawParams 中没有 bankAccountId，说明是新创建的）
    const isNewBankCard = !withdrawParams.value.bankParams?.bankAccountId
    // 如果创建了新银行卡，保存创建时的信息用于查找
    const createdBankInfo = isNewBankCard ? {
      flbBankNameId: withdrawParams.value.bankParams?.flbBankNameId,
      accountNumber: withdrawParams.value.bankParams?.accountNumber,
      accountHolder: withdrawParams.value.bankParams?.accountHolder,
      mobileNumber: withdrawParams.value.bankParams?.mobileNumber
    } : null

    await getUserBankCard()

    // 如果创建了新银行卡，自动选中并回显
    if (isNewBankCard && createdBankInfo) {
      // 通过银行ID、账号等信息匹配新创建的银行卡
      const newBankCard = userbankcard.value.find((card: any) => {
        return card.flbBankNameId === createdBankInfo.flbBankNameId &&
          card.accountNumber === createdBankInfo.accountNumber &&
          card.accountHolder === createdBankInfo.accountHolder &&
          card.mobileNumber === createdBankInfo.mobileNumber
      })

      if (newBankCard) {
        // 自动回显新创建的银行卡
        params.value.bankCardName = newBankCard.bankName
        params.value.bankAccountId = newBankCard.id
        const bankname = withdrawbankname.value.find((item) => {
          return item.value == newBankCard.flbBankNameId
        })
        params.value.flbBankName = bankname?.text
        params.value.flbBankNameId = newBankCard.flbBankNameId
        // 回显其他信息
        params.value.accountNumber = newBankCard.accountNumber || ''
        params.value.accountHolder = newBankCard.accountHolder || ''
        params.value.mobileNumber = newBankCard.mobileNumber || ''
        // 重置新增银行卡状态
        isAddingNewBankCard.value = false
      } else {
        // 如果找不到匹配的银行卡，清空表单
        params.value.accountNumber = ''
        params.value.accountHolder = ''
        params.value.mobileNumber = ''
        params.value.bankCardName = ''
        params.value.bankAccountId = ''
        params.value.flbBankName = ''
        params.value.flbBankNameId = ''
        // 重置新增银行卡状态
        isAddingNewBankCard.value = false
      }
    } else {
      // 如果没有创建新银行卡，清空表单（保留金额）
      params.value.accountNumber = ''
      params.value.accountHolder = ''
      params.value.mobileNumber = ''
      params.value.bankCardName = ''
      params.value.bankAccountId = ''
      params.value.flbBankName = ''
      params.value.flbBankNameId = ''
      // 重置新增银行卡状态
      isAddingNewBankCard.value = false
    }
    // 注意：不清空 amount、searchText 和 selectedRechargeIdx，保留用户输入的金额
    // 显示成功提示
    ; (window as any).$toast(t('wallet.withdrawalInitiatedSuccess'))
  } catch (error) {
    console.error('Failed to refresh data:', error)
      // 即使刷新失败，也显示成功提示
      ; (window as any).$toast(t('wallet.withdrawalInitiatedSuccess'))
  }
}

// 处理提现密码错误
function handleWithdrawPasswordError(errorMessage: string) {
  showWithdrawPasswordModal.value = false
  isWithdrawing.value = false
    // 显示错误信息
    ; (window as any).$toast(errorMessage)
}

function handleRechargeClick() {
  // 防抖：如果正在提现中，直接返回
  if (isWithdrawing.value) {
    return
  }

  // 如果按钮被禁用，直接返回
  if (isWithdrawDisabled.value) {
    return
  }

  // 设置防抖状态
  isWithdrawing.value = true

  // 检查CPF验证
  // if (cpfError.value) {
  //   ; (window as any).$toast('CPF inválido, por favor insira um CPF válido')
  //   return
  // }

  // 如果有银行卡且不在添加新银行卡状态，必须选择银行卡
  if (userbankcard.value.length > 0 && !isAddingNewBankCard && (!params.value.bankCardName || !params.value.bankAccountId)) {
    isWithdrawing.value = false
      ; (window as any).$toast(t('wallet.pleaseSelectBankCard'))
    return
  }

  // 校验银行名称（如果没有银行卡或银行卡选择后没有自动填充银行名称）
  if (!params.value.flbBankName || !params.value.flbBankNameId) {
    isWithdrawing.value = false
      ; (window as any).$toast(t('wallet.pleaseEnterBank'))
    return
  }

  // 如果银行名称是GCash，只校验手机号格式（GCash不需要银行卡号）
  if (params.value.flbBankName === 'GCash') {
    // 校验手机号
    if (!params.value.mobileNumber) {
      isWithdrawing.value = false
        ; (window as any).$toast(t('wallet.pleaseEnterPhone'))
      return
    }
    if (!validateGCashMobile(params.value.mobileNumber)) {
      isWithdrawing.value = false
      mobileNumberError.value = true
        ; (window as any).$toast(t('wallet.gcashMobileFormatError'))
      return
    }
  }

  trackWithdrawClickNowButton()
  rechargeBtnAnimated.value = false
  void rechargeBtnAnimated.value // 强制刷新
  setTimeout(() => { rechargeBtnAnimated.value = true }, 10)
  setTimeout(() => { rechargeBtnAnimated.value = false }, 400);

  // 只调用一次接口检查所有条件
  checkWithdrawConditions().then(({ hasMultiplier, needPassword, needInputPassword }) => {

    // 如果需要设置二级密码，弹窗已经在 checkWithdrawConditions 中显示了
    if (needPassword) {
      console.log('需要设置二级密码，弹窗已显示')
      isWithdrawing.value = false
      return
    }

    // 如果有投注倍数要求，弹窗已经在 checkWithdrawConditions 中显示了
    if (hasMultiplier) {
      console.log('有投注倍数要求，弹窗已显示')
      isWithdrawing.value = false
      return
    }

    // 如果需要输入提现密码，弹窗已经在 checkWithdrawConditions 中显示了
    if (needInputPassword) {
      console.log('需要输入提现密码，弹窗已显示')
      // 注意：这里不重置 isWithdrawing，因为密码弹窗确认后会继续提现流程
      // 但是如果密码错误，handleWithdrawPasswordError 会重置 isWithdrawing
      return
    }

    // 如果都不需要，根据 withdrawPasswordSwitch 决定是否弹密码弹窗
    if (!hasMultiplier && !needPassword && !needInputPassword) {
      // 如果 withdrawPasswordSwitch 为 false，不弹密码弹窗，直接调用提现接口
      if (!withdrawPasswordSwitch.value) {
        // 直接提现，不弹密码弹窗
        prepareWithdrawParamsOnly().then(async () => {
          await handleDirectWithdraw()
          isWithdrawing.value = false
        }).catch(error => {
          console.error('Failed to prepare withdraw params:', error)
          isWithdrawing.value = false
          // 错误提示已在 prepareWithdrawParamsOnly 中显示
        })
      } else {
        // 弹出密码输入弹窗
        prepareWithdrawParamsOnly().then(() => {
          showWithdrawPasswordModal.value = true
          // 注意：这里不重置，因为密码弹窗确认后会继续提现流程
        }).catch(error => {
          console.error('Failed to prepare withdraw params:', error)
          isWithdrawing.value = false
          // 错误提示已在 prepareWithdrawParamsOnly 中显示
        })
      }
    }
  }).catch(error => {
    console.error('Failed to check withdraw conditions:', error)
    isWithdrawing.value = false
      ; (window as any).$toast('Failed to check withdrawal conditions')
  })
}

// 直接提现函数 - 当 withdrawPasswordSwitch 为 false 时使用，不弹密码弹窗
async function handleDirectWithdraw() {
  try {
    const withdrawData = withdrawParams.value as any
    if (!withdrawData || !withdrawData.bankParams) {
      isWithdrawing.value = false
        ; (window as any).$toast('Withdrawal failed')
      return
    }

    // 先调用 create 接口创建银行信息（如果需要）
    let bankAccountId

    // 所有渠道类型都走相同逻辑：有银行卡就走提现，没有就走创建
    // 如果已有 bankAccountId，直接使用（走提现接口）
    if (withdrawData.bankParams && withdrawData.bankParams.bankAccountId) {
      bankAccountId = withdrawData.bankParams.bankAccountId
    } else {
      // 创建新的银行信息（走 create 接口）
      // 所有渠道都使用 bankParams
      const createParams = withdrawData.bankParams

      // 添加调试日志
      console.log('创建银行卡接口参数:', {
        paymentType: withdrawData.paymentType,
        createParams
      })

      // 检查参数是否为空
      if (!createParams || Object.keys(createParams).length === 0) {
        isWithdrawing.value = false
          ; (window as any).$toast('Bank information is required')
        console.error('创建银行卡参数为空:', createParams)
        return
      }

      const response = await GameApi.createbankInformation(createParams) as any
      if (response.code === 0) {
        bankAccountId = response.data
      } else {
        isWithdrawing.value = false
          ; (window as any).$toast(response.msg || 'Failed to create bank information')
        return
      }
    }

    // 确保 bankAccountId 存在（无论是 1 还是 2，都需要 bankAccountId）
    if (!bankAccountId) {
      isWithdrawing.value = false
        ; (window as any).$toast('Bank account ID is required')
      return
    }

    // 构建提现参数，不传密码（或传空密码）
    const withdrawRequestParams: any = {
      flbBankNameId: withdrawData.bankParams.flbBankNameId,
      userId: withdrawData.userId,
      withdrawAmount: withdrawData.withdrawAmount,
      currency: withdrawData.currency,
      bankAccountId: bankAccountId,
      paymentType: withdrawData.paymentType,
      withdrawPassword: '', // 不传密码或传空密码
      mobileNumber: withdrawData.bankParams.mobileNumber,
      accountHolder: withdrawData.bankParams.accountHolder,
    }

    // GCash不需要传递accountNumber，其他银行需要
    if (withdrawData.bankParams.accountNumber) {
      withdrawRequestParams.accountNumber = withdrawData.bankParams.accountNumber
    }

    // 调用提现接口
    const withdrawResponse = await GameApi.withdraw(withdrawRequestParams) as any
    console.log('提现接口响应:', withdrawResponse)

    // 处理提现响应
    // 检查响应结构：可能是 response.code 或 response.data.code
    const responseCode = withdrawResponse?.code ?? withdrawResponse?.data?.code
    const isSuccess = responseCode === 0 || responseCode === 200

    if (isSuccess) {
      // 刷新用户信息和银行卡列表
      try {
        await userStore.info()
        // 如果创建了新银行卡，保存bankAccountId用于回显
        const createdBankAccountId = bankAccountId
        await getUserBankCard()

        // 如果创建了新银行卡，自动选中并回显
        if (createdBankAccountId && !withdrawData.bankParams.bankAccountId) {
          const newBankCard = userbankcard.value.find((card: any) => card.id === createdBankAccountId)
          if (newBankCard) {
            // 自动回显新创建的银行卡
            params.value.bankCardName = newBankCard.bankName
            params.value.bankAccountId = newBankCard.id
            const bankname = withdrawbankname.value.find((item) => {
              return item.value == newBankCard.flbBankNameId
            })
            params.value.flbBankName = bankname?.text
            params.value.flbBankNameId = newBankCard.flbBankNameId
            // 回显其他信息
            params.value.accountNumber = newBankCard.accountNumber || ''
            params.value.accountHolder = newBankCard.accountHolder || ''
            params.value.mobileNumber = newBankCard.mobileNumber || ''
            // 重置新增银行卡状态
            isAddingNewBankCard.value = false
          }
        } else {
          // 如果没有创建新银行卡，清空表单（保留金额）
          params.value.accountNumber = ''
          params.value.accountHolder = ''
          params.value.mobileNumber = ''
          params.value.bankCardName = ''
          params.value.bankAccountId = ''
          params.value.flbBankName = ''
          params.value.flbBankNameId = ''
          // 重置新增银行卡状态
          isAddingNewBankCard.value = false
        }
        // 注意：不清空 amount、searchText 和 selectedRechargeIdx，保留用户输入的金额
      } catch (error) {
        console.error('Failed to refresh data:', error)
      }
      // 显示成功提示
      ; (window as any).$toast(t('wallet.withdrawalInitiatedSuccess'))
      isWithdrawing.value = false
    } else {
      isWithdrawing.value = false
      const errorMsg = withdrawResponse?.msg ?? withdrawResponse?.data?.msg ?? t('wallet.withdrawalFailed') ?? 'Withdrawal failed'
        ; (window as any).$toast(errorMsg)
    }
  } catch (error: any) {
    console.error('Direct withdraw failed:', error)
    isWithdrawing.value = false
      ; (window as any).$toast(error?.message || error?.msg || t('wallet.withdrawalFailed') || 'Withdrawal failed')
  }
}

// 提现请求函数 - 直接调用提现接口，让后端处理银行信息创建
async function submitWithdrawRequest() {
  try {
    // 验证必填字段
    if (!params.value.amount || Number(params.value.amount) <= 0) {
      return
    }

    // 验证巴西 CPF 必填字段
    if (!params.value.cpfName || !params.value.cpfId) {
      return
    }

    // 巴西 CPF 方式 - 直接传递CPF参数给提现接口
    const withdrawParams = {
      userId: userStore.userInfo.userId,
      withdrawAmount: Number(params.value.amount),
      currency: VITE_PLATFORM,
      cpfParams: {
        pixCpf: params.value.cpfId,
        accountHolder: params.value.cpfName,
        userId: userStore.userInfo.userId,
        userName: userStore.userInfo.userId
      },
      paymentType: parsmestype.value
    }

    // 统一调用提现接口
    const response = await GameApi.withdraw(withdrawParams)

    // 统一处理响应 - 修复类型错误
    if (response.data && (response.data.code === 0 || response.data.code === 200)) {
      ; (window as any).$toast(t('wallet.withdrawalSuccessful'))
      // 可以在这里添加其他成功后的逻辑，比如跳转页面等
    } else {
    }

    // 注释：原来的 Bank Card 和 UPI 逻辑保留备用
    // // 根据选择的提现方式构建不同的请求参数
    // let withdrawParams
    // if (selectedWithdrawMethod.value === 'Bank Card') {
    //   // 验证 Bank Card 必填字段
    //   if (!params.value.bank || !params.value.bankAccountNumber || !params.value.withdrawalName ||
    //       !params.value.mobilePhone || !params.value.email || !params.value.ifscCode) {
    //     return
    //   }
    //
    //   // Bank Card 方式 - 直接传递银行参数给提现接口
    //   withdrawParams = {
    //     userId: userStore.userInfo.userId,
    //     withdrawAmount: Number(params.value.amount),
    //     currency: VITE_PLATFORM,
    //     bankParams: {
    //       bankName: params.value.bank,
    //       accountNumber: params.value.bankAccountNumber,
    //       accountHolder: params.value.withdrawalName,
    //       mobileCountryCode:VITE_AREA_CODE,
    //       mobileNumber: params.value.mobilePhone,
    //       email: params.value.email,
    //       ifscCode: params.value.ifscCode,
    //       userId: userStore.userInfo.userId,
    //       userName: userStore.userInfo.userId
    //     },
    //     paymentType: 2 // 2表示银行卡
    //   }
    // } else if (selectedWithdrawMethod.value === 'UPI ID') {
    //   // 验证 UPI ID 必填字段
    //   if (!params.value.upiName || !params.value.upiPhone || !params.value.upiEmail || !params.value.upiId) {
    //     return
    //   }
    //
    //   // UPI ID 方式 - 直接传递UPI参数给提现接口
    //   withdrawParams = {
    //     userId: userStore.userInfo.userId,
    //     withdrawAmount: Number(params.value.amount),
    //     currency: VITE_PLATFORM,
    //     upiParams: {
    //       upi: params.value.upiId,
    //       accountHolder: params.value.upiName,
    //       mobileCountryCode: VITE_AREA_CODE,
    //       mobileNumber: params.value.upiPhone,
    //       email: params.value.upiEmail
    //     },
    //     paymentType: 1 // 1表示UPI
    //   }
    // } else {
    //   return
    // }

  } catch (error) {
  }
}

const goRecord = () => {
  router.push('/wallet/chargebackRecord')
}

// 添加跳转到稽核页面的函数
const goToAuditPage = () => {
  router.push('/wallet/chargebackRecord?tab=audit')
}

// 检查是否从个人中心跳转
const isFromPerson = computed(() => {
  return sessionStorage.getItem('fromPerson') === 'true'
})

const onClickLeft = () => {
  if (isFromPerson.value) {
    // 如果是从个人中心来的，清除标记并返回个人中心
    sessionStorage.removeItem('fromPerson')
    router.push('/person')
  } else {
    router.back()
  }
}
</script>

<style lang="scss" scoped>
:deep(.van-picker) {
  background: #00554A;

  .van-picker-column__item--selected {
    color: #fff !important;
    font-weight: bold;
  }

  * {
    background: transparent;
  }
}

:deep(.van-popup.van-popup--center.van-dialog.deleteBankCardDialog) {
  background: #00554A;

  .van-dialog__header {
    color: #fff
  }

  button::before {
    background: #00554A;
  }

  .van-button--default {
    background: #00554A;
  }

  .van-button__text {
    color: #ADB1B0
  }

  .van-dialog__confirm {
    .van-button__text {
      color: #3FB565
    }
  }

}

.arrow {
  display: inline-block;
  margin-left: 16px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #60B289 !important;
  /* 添加!important确保优先级 */
  transition: transform 0.2s;
}

.wallet-page {
  --van-picker-background: transparent;
  --van-picker-mask-color: transparent;
  --van-picker-confirm-action-color: #00F8C2;
  --van-picker-option-text-color: #ADB1B0;
  --van-picker-option-font-size: 12px;
  --van-picker-toolbar-height: 64px;
}

.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.channels-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.channels-container::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.channels-scroll {
  display: flex;
  gap: 10px;
  min-width: fit-content;
  padding-bottom: 2px;
  /* 为滚动条留出空间 */
}

.Channels {
  width: 106px;
  height: 39px;
  flex-shrink: 0;
  /* 防止元素收缩 */
  background: #18553A;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  line-height: 39px;
  text-align: center;
  color: #5FB589;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.Channels.selected {
  background: linear-gradient(0deg, #18926B 0%, #299263 100%);
  box-shadow: 0px 2px 1px 0px rgba(0, 26, 26, 0.71), 0px 1px 0px 0px #5DC09B, 0px -1px 0px 0px #46B792;
  color: #FFFFFF;
}

.recharge-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 18px;
}

.recharge-item {
  background: #003C31;
  border-radius: 8px;
  color: #60B58A;
  font-size: 15px;
  font-weight: 500;
  height: 38px;
  line-height: 38px;
  text-align: center;
  transition: background 0.2s, color 0.2s, font-weight 0.2s;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.recharge-item.selected {
  background: linear-gradient(0deg, #18926B 0%, #299263 100%);
  box-shadow: 0px 2px 1px 0px rgba(0, 26, 26, 0.71), 0px 1px 0px 0px #5DC09B, 0px -1px 0px 0px #46B792;
  color: #fff;
  font-weight: bold;
}

.moneyseary {
  height: 40px;
  background: #00422F !important;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 10px 7px;
  margin-top: 17px;
  gap: 8px;
}

.money-prefix {
  color: #fff;
  font-size: 14px;
  flex-shrink: 0;
  font-weight: bold;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 12px;
  height: 100%;
  margin-left: 10px;
  margin-right: 5px;
  width: 100%;
  /* 确保input占满容器宽度 */
}

/* 为表单输入框添加更长的样式 */
.steinput {
  width: 100% !important;
  min-width: 280px;
  /* 设置最小宽度 */
  padding-right: 30px;
  /* 为清除按钮留出空间 */
}

/* 为带清除按钮的输入框调整样式 */
.relative .steinput {
  padding-right: 40px;
  /* 为清除按钮留出更多空间 */
}

/* 为手机号输入框调整样式 */
.flex .steinput {
  flex: 1;
  min-width: 200px;
  /* 手机号输入框的最小宽度 */
}

.money-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

input::placeholder {
  color: #89A89F;
  font-size: 12px;
}

/* 修改 placeholder 样式，确保生效 */
.steinput::placeholder {
  color: #308a68 !important;
  font-size: 12px;
}

/* 添加浏览器兼容性支持 */
.steinput::-webkit-input-placeholder {
  color: #308a68 !important;
  font-size: 12px;
}

.steinput::-moz-placeholder {
  color: #308a68 !important;
  font-size: 12px;
  opacity: 1;
}

.steinput:-ms-input-placeholder {
  color: #308a68 !important;
  font-size: 12px;
}

.steinput:-moz-placeholder {
  color: #308a68 !important;
  font-size: 12px;
  opacity: 1;
}

.bodeeryle {
  width: 78px;
  height: 33px;
  background: #18553A;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  border: 1px solid #006849;
  line-height: 33px;
  text-align: center;
  color: #5FB589;
  font-size: 13px;
  font-weight: bold;
  margin-right: 11px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.bodeeryle.selected {
  background: #11412F;
  border: 1px solid #17B663;
  color: #fff;
}

.input-underline {
  height: 1px;
  background: #339A74;
  border-radius: 1px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: background 0.3s, height 0.3s;
}

.input-underline.focused {
  background: #009F76;
  height: 1px;
  animation: underline-grow 0.3s;
}


.input-error-tip {
  display: flex;
  align-items: baseline;
  color: #ff4d4f;
  font-size: 13px;
}

@keyframes underline-grow {
  0% {
    width: 0;
    left: 50%;
  }

  100% {
    width: 100%;
    left: 0;
  }
}


.Recharge::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #fff 0%, #43C36B 50%, #fff 100%);
  opacity: 0.25;
  border-radius: 6px;
  transform: translateX(-50%) scaleX(0);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  pointer-events: none;
}

.Recharge.animated::before {
  transform: translateX(-50%) scaleX(1);
}

.Recharge,
.Recharge>* {
  position: relative;
  z-index: 2;
}

.Recharge.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.betting-requirement {
  background: #18553A;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid #009F76;
}

.requirement-text {
  color: #60B289;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 10px;
}

.see-details-btn {
  color: #2A6AB4;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  text-align: center;
  transition: color 0.3s ease;
}

.see-details-btn:hover {
  color: #1E5A9B;
}
</style>
<route lang="json5">
  {
    name: 'wallet',
    meta: {
      title: '钱包',
      i18n: 'menus.wallet'
    },
  }
</route>
